import { enums } from "@shared/constants";
import { getPriceLocale } from "@shared/modules/financials/utils/price-utils";
import { CurrencyFormatSharedProps } from "./CurrencyFormat.props";

// format the thousand separator based on the current locale
export const getThousandSeparator = (
  value: CurrencyFormatSharedProps["value"]
) => {
  const locale = getPriceLocale();

  // default is no thousand separator
  // (prevents an error where the thousand and decimal separators are the same character)
  const defaultSeparator = "";

  return (
    Intl.NumberFormat(locale)
      .formatToParts(Number(value))
      .find((part) => part.type === "group")?.value ?? defaultSeparator
  );
};

// format the decimal separator based on the current locale
export const getDecimalSeparator = () => {
  const locale = getPriceLocale();

  switch (locale) {
    case "fr":
      return ",";
    default:
      return ".";
  }
};

export const getPrefix = (
  currency: CurrencyFormatSharedProps["currency"] = "CAD",
  accountingFormat = false,
  value: CurrencyFormatSharedProps["value"]
) => {
  const { symbol } = enums.CURRENCY_MAP[currency];

  if (accountingFormat && Number(value) < 0) {
    return `(${symbol}`;
  }

  return symbol;
};

export const getSuffix = (
  currency: CurrencyFormatSharedProps["currency"] = "CAD",
  accountingFormat = false,
  value: CurrencyFormatSharedProps["value"],
  includeSuffix = false
) => {
  let suffix = "";

  if (includeSuffix) {
    suffix = suffix.concat(` ${currency}`);
  }

  if (accountingFormat && Number(value) < 0) {
    suffix = suffix.concat(")");
  }

  return suffix;
};
